import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import AdminLogin from "@/pages/AdminLogin";
import AdminForgot from "@/pages/AdminForgot";
import AdminReset from "@/pages/AdminReset";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminShopEdit from "@/pages/AdminShopEdit";
import AdminLandingEdit from "@/pages/AdminLandingEdit";
import AdminPromoVideos from "@/pages/AdminPromoVideos";
import PublicLanding from "@/pages/PublicLanding";
import ShopLanding from "@/pages/ShopLanding";
import ShopInput from "@/pages/ShopInput";
import ShopAdmin from "@/pages/ShopAdmin";
import ShopReports from "@/pages/ShopReports";
import ShopKPI from "@/pages/ShopKPI";
import NotFound from "@/pages/NotFound";

function AdminRoute({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/forgot-password" element={<AdminForgot />} />
      <Route path="/reset-password" element={<AdminReset />} />
      <Route path="/" element={<PublicLanding />} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/landing" element={<AdminRoute><AdminLandingEdit /></AdminRoute>} />
      <Route path="/admin/promo-videos" element={<AdminRoute><AdminPromoVideos /></AdminRoute>} />
      <Route path="/admin/shops/:shopId" element={<AdminRoute><AdminShopEdit /></AdminRoute>} />
      <Route path="/:slug" element={<ShopLanding />} />
      <Route path="/:slug/input" element={<ShopInput />} />
      <Route path="/:slug/admin" element={<ShopAdmin />} />
      <Route path="/:slug/reports" element={<ShopReports />} />
      <Route path="/:slug/kpi" element={<ShopKPI />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster richColors position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
